import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { isLoginVisibleSelector } from "@client/widgets/SidePanel/selectors";
import Component from "./component";

import "./style.less";

const mapStateToProps = (state: AppState): WithIsVisibleHOCProps => {
  const isVisible = isLoginVisibleSelector(state);
  return {
    isVisible
  };
};

export default connectCustom(mapStateToProps)(Component);
